import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * SettlementMethod Partial Translation Cell
 * Translates settlementMethod enums into relevant strings
 */
export const settlementmethodPartial: Columns<any> = {
  title: 'Afregningsform',
  key: 'settlementMethod',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    nonprofiled: 'enum.settlementmethod.nonprofiled',
    flexsettled: 'enum.settlementmethod.flexsettled',
    notspecified: 'enum.settlementmethod.notspecified',
    profiled: 'enum.settlementmethod.profiled',
  }
}
